var _rect, _rect2, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMeetBg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 2,
    width: 32,
    height: 32,
    rx: 16,
    fill: "#EEEEEE"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 2,
    width: 32,
    height: 32,
    rx: 16,
    stroke: "#F6F6F6",
    strokeWidth: 4
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_42553_92033)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14 11.3984L10 15.3984L12 16.6365L14 15.3984L15.1294 13.3984L14 11.3984Z",
    fill: "#FF2820"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14 15.3984H10V20.5984L12 21.6967L14 20.5984V15.3984Z",
    fill: "#0084FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 20.5938V23.2604C10 23.9937 10.6 24.5938 11.3333 24.5938H14L15.1294 22.4706L14 20.5938H10Z",
    fill: "#0066DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.1792 12.8233L22.7053 14.783V14.8031L21.8984 17.8834L22.7053 21.0007L25.1682 22.9829C25.4986 23.2602 26.0053 23.0273 26.0053 22.5948V13.2115C26.0053 12.7789 25.5096 12.546 25.1792 12.8233Z",
    fill: "#00AD3C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.7 14.7783V12.7165C22.7 11.9916 22.1127 11.3984 21.395 11.3984H18.785H14V15.3984H18.9V17.9984L21.5326 17.7052L22.7 14.7783Z",
    fill: "#FFBA00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.9 20.6H14V24.6H18.785H21.395C22.1127 24.6 22.7 24.0078 22.7 23.2839V21L21.394 18.3168L18.9 18V20.6Z",
    fill: "#00AD3C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.8984 18.0013L22.6984 21.0013V14.7812L18.8984 18.0013Z",
    fill: "#00831E"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_42553_92033"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(10 10)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMeetBg);
export default __webpack_public_path__ + "static/media/meet-bg.da8a3533dba43cc44ab595b28fa59c2f.svg";
export { ForwardRef as ReactComponent };